/**
 * Enrollments React Query Hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { enrollmentService } from '../services';

const ENROLLMENTS_KEY = 'enrollments';

export function useEnrollments(params = {}) {
  return useQuery({
    queryKey: [ENROLLMENTS_KEY, params],
    queryFn: () => enrollmentService.getAll(params),
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreateEnrollment() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: enrollmentService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ENROLLMENTS_KEY] });
    },
  });
}

export function useUpdateEnrollment() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }) => enrollmentService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ENROLLMENTS_KEY] });
    },
  });
}

export function useDeleteEnrollment() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: enrollmentService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ENROLLMENTS_KEY] });
    },
  });
}
